// Triggers the lazy() import for a route on hover/touch so the chunk is
// in cache by the time the user clicks. Each loader runs at most once.
const loaders: Record<string, () => Promise<unknown>> = {
  "/empresa": () => import("@/pages/Empresa"),
  "/solucoes": () => import("@/pages/Solucoes"),
  "/atuacao": () => import("@/pages/Atuacao"),
  "/aplicativo": () => import("@/pages/Aplicativo"),
  "/faq": () => import("@/pages/FAQ"),
  "/contato": () => import("@/pages/Contato"),
  "/informativo-app": () => import("@/pages/InformativoApp"),
};

const cache = new Map<string, Promise<unknown>>();

export function prefetchRoute(path: string) {
  const loader = loaders[path];
  if (!loader) return;
  if (!cache.has(path)) cache.set(path, loader());
}
